var map = {
	"./ActivityLog": 44173,
	"./ActivityLog.jsx": 44173,
	"./Ad": 57955,
	"./Ad.jsx": 57955,
	"./AddSentenceToCollection": 11259,
	"./AddSentenceToCollection.jsx": 11259,
	"./AddSentenceToCollectionBtn": 65935,
	"./AddSentenceToCollectionBtn.jsx": 65935,
	"./AddSentenceToCollectionModal": 78780,
	"./AddSentenceToCollectionModal.jsx": 78780,
	"./AddToCollectionLight": 44994,
	"./AddToCollectionLight.jsx": 44994,
	"./ArticleRunner": 43342,
	"./ArticleRunner.jsx": 43342,
	"./ArticleRunner/GameOver": 71599,
	"./ArticleRunner/GameOver.jsx": 71599,
	"./ArticleRunner/Leaderboard": 42914,
	"./ArticleRunner/Leaderboard.jsx": 42914,
	"./ArticleRunner/engine": 82223,
	"./ArticleRunner/engine.js": 82223,
	"./ArticleRunner/render": 86881,
	"./ArticleRunner/render.js": 86881,
	"./ArticleRunner/share": 14738,
	"./ArticleRunner/share.js": 14738,
	"./AutoScrollablePre": 34527,
	"./AutoScrollablePre.jsx": 34527,
	"./BlackFridayBanner": 26800,
	"./BlackFridayBanner.jsx": 26800,
	"./BlackFridayOffer": 78566,
	"./BlackFridayOffer.jsx": 78566,
	"./ChatBot": 97227,
	"./ChatBot.jsx": 97227,
	"./Checkbox": 68135,
	"./Checkbox.jsx": 68135,
	"./ClozeSelectable": 46177,
	"./ClozeSelectable.jsx": 46177,
	"./ClozeSentence": 68462,
	"./ClozeSentence.jsx": 68462,
	"./ClozeSentenceSearch": 75922,
	"./ClozeSentenceSearch.jsx": 75922,
	"./ClozeSentenceSearch/BulkAdd": 49982,
	"./ClozeSentenceSearch/BulkAdd.jsx": 49982,
	"./ClozeSentenceSearch/SearchForm": 55621,
	"./ClozeSentenceSearch/SearchForm.jsx": 55621,
	"./ClozeSentenceSearch/SearchResult": 94420,
	"./ClozeSentenceSearch/SearchResult.jsx": 94420,
	"./ClozeSentenceSearchModal": 80931,
	"./ClozeSentenceSearchModal.jsx": 80931,
	"./ClozeText/ClozeTextAddSentence": 30497,
	"./ClozeText/ClozeTextAddSentence.jsx": 30497,
	"./ClozeText/ClozeTextSaveToLearn": 58485,
	"./ClozeText/ClozeTextSaveToLearn.jsx": 58485,
	"./CollectionClozeSentenceEditor": 98401,
	"./CollectionClozeSentenceEditor.jsx": 98401,
	"./CollectionClozeSentenceEditorModal": 84842,
	"./CollectionClozeSentenceEditorModal.jsx": 84842,
	"./CollectionClozeSentenceExplanation": 7481,
	"./CollectionClozeSentenceExplanation.jsx": 7481,
	"./CollectionSelector": 96991,
	"./CollectionSelector.jsx": 96991,
	"./CompInputReader": 62340,
	"./CompInputReader.jsx": 62340,
	"./CompInputSentenceExplanation": 87137,
	"./CompInputSentenceExplanation.jsx": 87137,
	"./CompInputs": 5890,
	"./CompInputs.jsx": 5890,
	"./ConjugationPractice": 90204,
	"./ConjugationPractice.jsx": 90204,
	"./CopySentencePopover": 73677,
	"./CopySentencePopover.jsx": 73677,
	"./DailyGoalModal": 64225,
	"./DailyGoalModal.jsx": 64225,
	"./DailyGoalPanel": 9032,
	"./DailyGoalPanel.jsx": 9032,
	"./DailyGoalPanelV2": 3988,
	"./DailyGoalPanelV2.jsx": 3988,
	"./DailyGoalStats": 48507,
	"./DailyGoalStats.jsx": 48507,
	"./DailyReminderBtn": 79439,
	"./DailyReminderBtn.jsx": 79439,
	"./DailyReminderModal": 53884,
	"./DailyReminderModal.jsx": 53884,
	"./DailyReminderPanel": 92697,
	"./DailyReminderPanel.jsx": 92697,
	"./Dashboard": 71506,
	"./Dashboard.jsx": 71506,
	"./Dashboard/AddClozeFromWordsToCollectionModal": 50408,
	"./Dashboard/AddClozeFromWordsToCollectionModal.jsx": 50408,
	"./Dashboard/AddFileToCollectionModal": 66820,
	"./Dashboard/AddFileToCollectionModal.jsx": 66820,
	"./Dashboard/AddTextToCollectionModal": 16657,
	"./Dashboard/AddTextToCollectionModal.jsx": 16657,
	"./Dashboard/AddToCollectionModal": 44654,
	"./Dashboard/AddToCollectionModal.jsx": 44654,
	"./Dashboard/BulkSentenceCreationEditor": 98164,
	"./Dashboard/BulkSentenceCreationEditor.jsx": 98164,
	"./Dashboard/ChunkProgressBar": 70550,
	"./Dashboard/ChunkProgressBar.jsx": 70550,
	"./Dashboard/ClozeListeningCollectionComponent": 64688,
	"./Dashboard/ClozeListeningCollectionComponent.jsx": 64688,
	"./Dashboard/ClozeListeningPanel": 95779,
	"./Dashboard/ClozeListeningPanel.jsx": 95779,
	"./Dashboard/CollectionEditor": 70660,
	"./Dashboard/CollectionEditor.jsx": 70660,
	"./Dashboard/CollectionEditorModal": 45133,
	"./Dashboard/CollectionEditorModal.jsx": 45133,
	"./Dashboard/CollectionGroupingsPanel": 10447,
	"./Dashboard/CollectionGroupingsPanel.jsx": 10447,
	"./Dashboard/CollectionPanel": 99689,
	"./Dashboard/CollectionPanel.jsx": 99689,
	"./Dashboard/CollectionProgressBar": 8267,
	"./Dashboard/CollectionProgressBar.jsx": 8267,
	"./Dashboard/CollectionReviewSettingsModal": 97729,
	"./Dashboard/CollectionReviewSettingsModal.jsx": 97729,
	"./Dashboard/CollectionTableRow": 90131,
	"./Dashboard/CollectionTableRow.jsx": 90131,
	"./Dashboard/CollectionsModalTable": 90721,
	"./Dashboard/CollectionsModalTable.jsx": 90721,
	"./Dashboard/Core1kCollectionComponent": 51061,
	"./Dashboard/Core1kCollectionComponent.jsx": 51061,
	"./Dashboard/DeleteLanguagePairingModal": 69367,
	"./Dashboard/DeleteLanguagePairingModal.jsx": 69367,
	"./Dashboard/DownloadFavoritesModal": 93337,
	"./Dashboard/DownloadFavoritesModal.jsx": 93337,
	"./Dashboard/FastTrackComponent": 32835,
	"./Dashboard/FastTrackComponent.jsx": 32835,
	"./Dashboard/FastTrackPanel": 42856,
	"./Dashboard/FastTrackPanel.jsx": 42856,
	"./Dashboard/FastTrackStats": 66203,
	"./Dashboard/FastTrackStats.jsx": 66203,
	"./Dashboard/FastTrackStatsModal": 95164,
	"./Dashboard/FastTrackStatsModal.jsx": 95164,
	"./Dashboard/FastTrackV2Panel": 24868,
	"./Dashboard/FastTrackV2Panel.jsx": 24868,
	"./Dashboard/FavoritesModal": 51913,
	"./Dashboard/FavoritesModal.jsx": 51913,
	"./Dashboard/FollowClozemasterPanel": 51813,
	"./Dashboard/FollowClozemasterPanel.jsx": 51813,
	"./Dashboard/FrequencyCollectionsComponent": 75445,
	"./Dashboard/FrequencyCollectionsComponent.jsx": 75445,
	"./Dashboard/FullHistoryBtn": 71816,
	"./Dashboard/FullHistoryBtn.jsx": 71816,
	"./Dashboard/FullHistoryBtnV2": 44372,
	"./Dashboard/FullHistoryBtnV2.jsx": 44372,
	"./Dashboard/GoogleAdPanel": 33211,
	"./Dashboard/GoogleAdPanel.jsx": 33211,
	"./Dashboard/GooglePanelsAd": 94812,
	"./Dashboard/GooglePanelsAd.jsx": 94812,
	"./Dashboard/GoogleRightSidebarAd": 93719,
	"./Dashboard/GoogleRightSidebarAd.jsx": 93719,
	"./Dashboard/GrammarCollectionsComponent": 39576,
	"./Dashboard/GrammarCollectionsComponent.jsx": 39576,
	"./Dashboard/LanguagePairingSettingsModal": 50227,
	"./Dashboard/LanguagePairingSettingsModal.jsx": 50227,
	"./Dashboard/LanguagePairingSettingsModalV2": 25499,
	"./Dashboard/LanguagePairingSettingsModalV2.jsx": 25499,
	"./Dashboard/LeaderboardModal": 16279,
	"./Dashboard/LeaderboardModal.jsx": 16279,
	"./Dashboard/LeaderboardStatPanel": 5440,
	"./Dashboard/LeaderboardStatPanel.jsx": 5440,
	"./Dashboard/MasteryHelpModal": 29882,
	"./Dashboard/MasteryHelpModal.jsx": 29882,
	"./Dashboard/MoreStatsModal": 14296,
	"./Dashboard/MoreStatsModal.jsx": 14296,
	"./Dashboard/MyCollectionsPanel": 82994,
	"./Dashboard/MyCollectionsPanel.jsx": 82994,
	"./Dashboard/RandomCollectionComponent": 44893,
	"./Dashboard/RandomCollectionComponent.jsx": 44893,
	"./Dashboard/RankingsModal": 55047,
	"./Dashboard/RankingsModal.jsx": 55047,
	"./Dashboard/ResetProgressModal": 92024,
	"./Dashboard/ResetProgressModal.jsx": 92024,
	"./Dashboard/ReviewBtnPanel": 10485,
	"./Dashboard/ReviewBtnPanel.jsx": 10485,
	"./Dashboard/ReviewSettings": 74096,
	"./Dashboard/ReviewSettings.jsx": 74096,
	"./Dashboard/ReviewSettingsModal": 91313,
	"./Dashboard/ReviewSettingsModal.jsx": 91313,
	"./Dashboard/ReviewStatPanel": 51319,
	"./Dashboard/ReviewStatPanel.jsx": 51319,
	"./Dashboard/SharedCollection": 79800,
	"./Dashboard/SharedCollection.jsx": 79800,
	"./Dashboard/SharedCollectionsModal": 28358,
	"./Dashboard/SharedCollectionsModal.jsx": 28358,
	"./Dashboard/StatPanel": 95503,
	"./Dashboard/StatPanel.jsx": 95503,
	"./Dashboard/V3ClozeListeningPanel": 48616,
	"./Dashboard/V3ClozeListeningPanel.jsx": 48616,
	"./Dashboard/V3DailyGoalPanel": 16898,
	"./Dashboard/V3DailyGoalPanel.jsx": 16898,
	"./Dashboard/V3LeaderboardPanel": 22267,
	"./Dashboard/V3LeaderboardPanel.jsx": 22267,
	"./Dashboard/V3ReviewPanel": 68738,
	"./Dashboard/V3ReviewPanel.jsx": 68738,
	"./Dashboard/V3ReviewSettings": 92285,
	"./Dashboard/V3ReviewSettings.jsx": 92285,
	"./Dashboard/V3ReviewSettingsModal": 78174,
	"./Dashboard/V3ReviewSettingsModal.jsx": 78174,
	"./Dashboard/V3StreakPanel": 14228,
	"./Dashboard/V3StreakPanel.jsx": 14228,
	"./Dashboard/V5DailyGoalPanel": 79748,
	"./Dashboard/V5DailyGoalPanel.jsx": 79748,
	"./Dashboard/redux/reducers": 34268,
	"./Dashboard/redux/reducers/": 34268,
	"./Dashboard/redux/reducers/actionTypes": 35231,
	"./Dashboard/redux/reducers/actionTypes.js": 35231,
	"./Dashboard/redux/reducers/collections": 26797,
	"./Dashboard/redux/reducers/collections.js": 26797,
	"./Dashboard/redux/reducers/index": 34268,
	"./Dashboard/redux/reducers/index.js": 34268,
	"./Dashboard/redux/store": 96225,
	"./Dashboard/redux/store.js": 96225,
	"./Dashboard/trackProgressMetricSwitched": 9056,
	"./Dashboard/trackProgressMetricSwitched.js": 9056,
	"./DashboardV2-FAILED": 32734,
	"./DashboardV2-FAILED.jsx": 32734,
	"./DashboardV3": 58179,
	"./DashboardV3.jsx": 58179,
	"./DashboardV5": 89681,
	"./DashboardV5.jsx": 89681,
	"./DashboardV5/playsGrowth": 24872,
	"./DashboardV5/playsGrowth.js": 24872,
	"./Discover": 91621,
	"./Discover.jsx": 91621,
	"./DiscussionBtn": 17162,
	"./DiscussionBtn.jsx": 17162,
	"./DownloadAppBanner": 78663,
	"./DownloadAppBanner.jsx": 78663,
	"./ExplanationRequest": 15584,
	"./ExplanationRequest.jsx": 15584,
	"./ExplanationThread": 69679,
	"./ExplanationThread.jsx": 69679,
	"./FadeIn": 61291,
	"./FadeIn.jsx": 61291,
	"./FadeOut": 36460,
	"./FadeOut.jsx": 36460,
	"./FeedbackWidget": 64129,
	"./FeedbackWidget.jsx": 64129,
	"./FlagSprite": 28737,
	"./FlagSprite.jsx": 28737,
	"./FreeTypeFeedback": 83643,
	"./FreeTypeFeedback.jsx": 83643,
	"./FreeTypeFeedback/NativeVersion": 94033,
	"./FreeTypeFeedback/NativeVersion.jsx": 94033,
	"./FreeTypeFeedback/SaveToCollection": 81608,
	"./FreeTypeFeedback/SaveToCollection.jsx": 81608,
	"./FreeTypeFeedback/WritingIdea": 29947,
	"./FreeTypeFeedback/WritingIdea.jsx": 29947,
	"./FreeTypeFeedback/text": 55547,
	"./FreeTypeFeedback/text.js": 55547,
	"./FrenchNounArticles": 69909,
	"./FrenchNounArticles.jsx": 69909,
	"./FrenchNounArticles/Browse": 14932,
	"./FrenchNounArticles/Browse.jsx": 14932,
	"./FrenchNounArticles/FeedbackForm": 15673,
	"./FrenchNounArticles/FeedbackForm.jsx": 15673,
	"./FrenchNounArticles/ReportProblem": 3159,
	"./FrenchNounArticles/ReportProblem.jsx": 3159,
	"./FrenchNounArticles/RoundResults": 12696,
	"./FrenchNounArticles/RoundResults.jsx": 12696,
	"./FrenchNounArticles/Settings": 93805,
	"./FrenchNounArticles/Settings.jsx": 93805,
	"./FrenchNounArticles/SignUpPrompt": 12236,
	"./FrenchNounArticles/SignUpPrompt.jsx": 12236,
	"./FrenchNounArticles/audio": 5770,
	"./FrenchNounArticles/audio.js": 5770,
	"./FrenchNounArticles/celebration": 82876,
	"./FrenchNounArticles/celebration.js": 82876,
	"./FrenchNounArticles/deck": 35871,
	"./FrenchNounArticles/deck.js": 35871,
	"./FrenchNounArticles/options": 98422,
	"./FrenchNounArticles/options.js": 98422,
	"./FrenchNounArticles/useLabSync": 60731,
	"./FrenchNounArticles/useLabSync.js": 60731,
	"./FrenchNounArticles/useLocalStorage": 79139,
	"./FrenchNounArticles/useLocalStorage.js": 79139,
	"./GermanNounArticles": 17687,
	"./GermanNounArticles.jsx": 17687,
	"./GermanNounArticles/Browse": 78746,
	"./GermanNounArticles/Browse.jsx": 78746,
	"./GermanNounArticles/FeedbackForm": 12647,
	"./GermanNounArticles/FeedbackForm.jsx": 12647,
	"./GermanNounArticles/ReportProblem": 48477,
	"./GermanNounArticles/ReportProblem.jsx": 48477,
	"./GermanNounArticles/RoundResults": 64570,
	"./GermanNounArticles/RoundResults.jsx": 64570,
	"./GermanNounArticles/Settings": 73991,
	"./GermanNounArticles/Settings.jsx": 73991,
	"./GermanNounArticles/SignUpPrompt": 64218,
	"./GermanNounArticles/SignUpPrompt.jsx": 64218,
	"./GermanNounArticles/audio": 20552,
	"./GermanNounArticles/audio.js": 20552,
	"./GermanNounArticles/celebration": 37802,
	"./GermanNounArticles/celebration.js": 37802,
	"./GermanNounArticles/deck": 83741,
	"./GermanNounArticles/deck.js": 83741,
	"./GermanNounArticles/options": 40656,
	"./GermanNounArticles/options.js": 40656,
	"./GermanNounArticles/useLabSync": 61789,
	"./GermanNounArticles/useLabSync.js": 61789,
	"./GermanNounArticles/useLocalStorage": 11153,
	"./GermanNounArticles/useLocalStorage.js": 11153,
	"./GrammarExercise": 50059,
	"./GrammarExercise.jsx": 50059,
	"./GrammarExercise/ReportSentence": 67553,
	"./GrammarExercise/ReportSentence.jsx": 67553,
	"./GrammarUserExercise": 36158,
	"./GrammarUserExercise.jsx": 36158,
	"./Icon": 40727,
	"./Icon.jsx": 40727,
	"./IconCheckbox": 15596,
	"./IconCheckbox.jsx": 15596,
	"./InfiniteRadio": 89159,
	"./InfiniteRadio.jsx": 89159,
	"./InfiniteRadio/AddToCollection": 97252,
	"./InfiniteRadio/AddToCollection.jsx": 97252,
	"./InfiniteRadio/FeedbackForm": 38999,
	"./InfiniteRadio/FeedbackForm.jsx": 38999,
	"./InfiniteRadio/LineActions": 71921,
	"./InfiniteRadio/LineActions.jsx": 71921,
	"./InfiniteRadio/Lyrics": 82104,
	"./InfiniteRadio/Lyrics.jsx": 82104,
	"./InfiniteRadio/Visualizer": 59296,
	"./InfiniteRadio/Visualizer.jsx": 59296,
	"./InfiniteRadio/cloze": 89583,
	"./InfiniteRadio/cloze.js": 89583,
	"./InfiniteRadio/station": 88734,
	"./InfiniteRadio/station.js": 88734,
	"./InfiniteRadio/track": 54481,
	"./InfiniteRadio/track.js": 54481,
	"./Labs/VoteButton": 52161,
	"./Labs/VoteButton.jsx": 52161,
	"./Labs/useLocalStorage": 3464,
	"./Labs/useLocalStorage.js": 3464,
	"./Labs/useTheme": 77863,
	"./Labs/useTheme.js": 77863,
	"./LanguagePairingDropdown": 44987,
	"./LanguagePairingDropdown.jsx": 44987,
	"./LanguagePairingOrder": 19150,
	"./LanguagePairingOrder.jsx": 19150,
	"./LanguagePairings": 32793,
	"./LanguagePairings.jsx": 32793,
	"./Loading": 73898,
	"./Loading.jsx": 73898,
	"./LoadingOverlay": 74904,
	"./LoadingOverlay.jsx": 74904,
	"./ManageCollectionModal": 94870,
	"./ManageCollectionModal.jsx": 94870,
	"./ManageCollectionModal/CollectionClozeSentence": 20911,
	"./ManageCollectionModal/CollectionClozeSentence.jsx": 20911,
	"./ManageCollectionModal/CollectionClozeSentenceEditableAttribute": 755,
	"./ManageCollectionModal/CollectionClozeSentenceEditableAttribute.jsx": 755,
	"./Markdown": 29419,
	"./Markdown.jsx": 29419,
	"./MarkedAsKnownIcon": 28852,
	"./MarkedAsKnownIcon.jsx": 28852,
	"./MasteredIcon": 9830,
	"./MasteredIcon.jsx": 9830,
	"./MaxPlayedTodayModal": 18783,
	"./MaxPlayedTodayModal.jsx": 18783,
	"./MediaClips": 58429,
	"./MediaClips.jsx": 58429,
	"./MediaClips/ChannelTable": 80533,
	"./MediaClips/ChannelTable.jsx": 80533,
	"./MediaClips/hotkeys": 39887,
	"./MediaClips/hotkeys.js": 39887,
	"./MediaClips/useLocalStorage": 53115,
	"./MediaClips/useLocalStorage.js": 53115,
	"./MediaClips/useYouTubePlayer": 80999,
	"./MediaClips/useYouTubePlayer.js": 80999,
	"./Modal": 40897,
	"./Modal.jsx": 40897,
	"./ModalControl": 3158,
	"./ModalControl.jsx": 3158,
	"./ModalFooterCloseBtn": 508,
	"./ModalFooterCloseBtn.jsx": 508,
	"./ModalProPromo": 61703,
	"./ModalProPromo.jsx": 61703,
	"./NewCollectionForm": 73294,
	"./NewCollectionForm.jsx": 73294,
	"./Onboarding": 52143,
	"./Onboarding.jsx": 52143,
	"./OnboardingWelcome": 90075,
	"./OnboardingWelcome.jsx": 90075,
	"./PaddleCheckout": 55628,
	"./PaddleCheckout.jsx": 55628,
	"./Pagination": 86956,
	"./Pagination.jsx": 86956,
	"./Panel": 18152,
	"./Panel.jsx": 18152,
	"./PlayClozeListening": 80000,
	"./PlayClozeListening.jsx": 80000,
	"./PlayClozeListening/ReportModal": 42100,
	"./PlayClozeListening/ReportModal.jsx": 42100,
	"./PlayCollection": 83394,
	"./PlayCollection.jsx": 83394,
	"./PlayCollection/AccentButtons": 94626,
	"./PlayCollection/AccentButtons.jsx": 94626,
	"./PlayCollection/DiscussionModal": 50964,
	"./PlayCollection/DiscussionModal.jsx": 50964,
	"./PlayCollection/FlashcardSwipeable": 15413,
	"./PlayCollection/FlashcardSwipeable.jsx": 15413,
	"./PlayCollection/GameSettings": 43302,
	"./PlayCollection/GameSettings.jsx": 43302,
	"./PlayCollection/HelpModal": 45895,
	"./PlayCollection/HelpModal.jsx": 45895,
	"./PlayCollection/Hint": 80240,
	"./PlayCollection/Hint.jsx": 80240,
	"./PlayCollection/Incorrect": 52226,
	"./PlayCollection/Incorrect.jsx": 52226,
	"./PlayCollection/IntraRoundAd": 66148,
	"./PlayCollection/IntraRoundAd.jsx": 66148,
	"./PlayCollection/LandingSignUp": 3546,
	"./PlayCollection/LandingSignUp.jsx": 3546,
	"./PlayCollection/LeveledUpModal": 88622,
	"./PlayCollection/LeveledUpModal.jsx": 88622,
	"./PlayCollection/ListeningControl": 33405,
	"./PlayCollection/ListeningControl.jsx": 33405,
	"./PlayCollection/MorePracticeControls": 58005,
	"./PlayCollection/MorePracticeControls.jsx": 58005,
	"./PlayCollection/MultipleChoiceOptions": 19782,
	"./PlayCollection/MultipleChoiceOptions.jsx": 19782,
	"./PlayCollection/Points": 60846,
	"./PlayCollection/Points.jsx": 60846,
	"./PlayCollection/ReportErrorBtn": 93491,
	"./PlayCollection/ReportErrorBtn.jsx": 93491,
	"./PlayCollection/ReportErrorModal": 13104,
	"./PlayCollection/ReportErrorModal.jsx": 13104,
	"./PlayCollection/RoundHistoryModal": 85964,
	"./PlayCollection/RoundHistoryModal.jsx": 85964,
	"./PlayCollection/RoundResults": 89025,
	"./PlayCollection/RoundResults.jsx": 89025,
	"./PlayCollection/ShortcutsList": 23314,
	"./PlayCollection/ShortcutsList.jsx": 23314,
	"./PlayCollection/TeachingCollectionResultsForm": 11088,
	"./PlayCollection/TeachingCollectionResultsForm.jsx": 11088,
	"./PlayCollection/TextToSpeechSettings": 75148,
	"./PlayCollection/TextToSpeechSettings.jsx": 75148,
	"./PlayCollection/Tokens": 74885,
	"./PlayCollection/Tokens.jsx": 74885,
	"./PlayCollection/V5DailyReminderPrompt": 81053,
	"./PlayCollection/V5DailyReminderPrompt.jsx": 81053,
	"./PlayCollection/V5GameSettings": 18701,
	"./PlayCollection/V5GameSettings.jsx": 18701,
	"./PlayCollection/V5MultipleChoiceOptions": 94739,
	"./PlayCollection/V5MultipleChoiceOptions.jsx": 94739,
	"./PlayCollection/V5RoundResults": 47298,
	"./PlayCollection/V5RoundResults.jsx": 47298,
	"./PlayCollection/V5TextToSpeechSettings": 34435,
	"./PlayCollection/V5TextToSpeechSettings.jsx": 34435,
	"./PlayCollection/VoiceRecorder": 44931,
	"./PlayCollection/VoiceRecorder.jsx": 44931,
	"./PlayCollection/flashcard": 57517,
	"./PlayCollection/flashcard.js": 57517,
	"./PlayCollectionV2": 63014,
	"./PlayCollectionV2.jsx": 63014,
	"./PlayCollectionV5": 5287,
	"./PlayCollectionV5.jsx": 5287,
	"./PlayOptionsModal": 64639,
	"./PlayOptionsModal.jsx": 64639,
	"./PlaySystemTtsButton": 46402,
	"./PlaySystemTtsButton.jsx": 46402,
	"./PlayingIcon": 50715,
	"./PlayingIcon.jsx": 50715,
	"./ProSubscribeModal": 2580,
	"./ProSubscribeModal.jsx": 2580,
	"./ProgressBar": 20126,
	"./ProgressBar.jsx": 20126,
	"./PublicRadio": 31842,
	"./PublicRadio.jsx": 31842,
	"./QuickCapture": 73337,
	"./QuickCapture.jsx": 73337,
	"./QuickCapture/Entry": 96284,
	"./QuickCapture/Entry.jsx": 96284,
	"./QuickCapture/EntryDropdown": 54515,
	"./QuickCapture/EntryDropdown.jsx": 54515,
	"./QuickCapture/EntryExplanation": 55471,
	"./QuickCapture/EntryExplanation.jsx": 55471,
	"./QuickCapture/Imports": 89462,
	"./QuickCapture/Imports.jsx": 89462,
	"./QuickCapture/useClozeSelection": 64698,
	"./QuickCapture/useClozeSelection.js": 64698,
	"./QuickCapture/wrapClozeSelection": 52987,
	"./QuickCapture/wrapClozeSelection.js": 52987,
	"./QuickCaptureBtn": 9921,
	"./QuickCaptureBtn.jsx": 9921,
	"./QuickCaptureModal": 64962,
	"./QuickCaptureModal.jsx": 64962,
	"./QuickCapturePanel": 33607,
	"./QuickCapturePanel.jsx": 33607,
	"./QuickDemo": 64942,
	"./QuickDemo.jsx": 64942,
	"./Radio": 28499,
	"./Radio.jsx": 28499,
	"./Rankings": 89977,
	"./Rankings.jsx": 89977,
	"./ReportedCollectionClozeSentences": 79585,
	"./ReportedCollectionClozeSentences/": 79585,
	"./ReportedCollectionClozeSentences/AiSuggestedChanges": 29593,
	"./ReportedCollectionClozeSentences/AiSuggestedChanges.jsx": 29593,
	"./ReportedCollectionClozeSentences/index": 79585,
	"./ReportedCollectionClozeSentences/index.js": 79585,
	"./ResourceLinks": 4349,
	"./ResourceLinks.jsx": 4349,
	"./SaleCountdownTimer": 70485,
	"./SaleCountdownTimer.jsx": 70485,
	"./Select": 55216,
	"./Select.jsx": 55216,
	"./SelectionPopover": 72717,
	"./SelectionPopover.jsx": 72717,
	"./SelectionPopoverableLink": 50933,
	"./SelectionPopoverableLink.jsx": 50933,
	"./SelectionSlideout": 92313,
	"./SelectionSlideout.jsx": 92313,
	"./SelectionToken": 27025,
	"./SelectionToken.jsx": 27025,
	"./SelectionTokenText": 58896,
	"./SelectionTokenText.jsx": 58896,
	"./SlideDown": 20997,
	"./SlideDown.jsx": 20997,
	"./Slideout": 18173,
	"./Slideout.jsx": 18173,
	"./SpeechSynthesisBtn": 69204,
	"./SpeechSynthesisBtn.jsx": 69204,
	"./SpeechToText": 46752,
	"./SpeechToText.jsx": 46752,
	"./Stories/ClozeOptionsPanel": 59815,
	"./Stories/ClozeOptionsPanel.jsx": 59815,
	"./Stories/ClozeStoryResults": 52276,
	"./Stories/ClozeStoryResults.jsx": 52276,
	"./Stories/FeatureFeedbackBanner": 96761,
	"./Stories/FeatureFeedbackBanner.jsx": 96761,
	"./Stories/FeatureFeedbackSheet": 30190,
	"./Stories/FeatureFeedbackSheet.jsx": 30190,
	"./Stories/NewClozeTextSheet": 32157,
	"./Stories/NewClozeTextSheet.jsx": 32157,
	"./Stories/SendFeedbackButton": 95385,
	"./Stories/SendFeedbackButton.jsx": 95385,
	"./Stories/StoriesLibrary": 71342,
	"./Stories/StoriesLibrary.jsx": 71342,
	"./Stories/StoryAudioBar": 73906,
	"./Stories/StoryAudioBar.jsx": 73906,
	"./Stories/StoryCompletionOverlay": 32353,
	"./Stories/StoryCompletionOverlay.jsx": 32353,
	"./Stories/StoryFeedbackSheet": 67685,
	"./Stories/StoryFeedbackSheet.jsx": 67685,
	"./Stories/StoryFilterChip": 98639,
	"./Stories/StoryFilterChip.jsx": 98639,
	"./Stories/StoryFiltersSheet": 97977,
	"./Stories/StoryFiltersSheet.jsx": 97977,
	"./Stories/StoryInfoSheet": 81550,
	"./Stories/StoryInfoSheet.jsx": 81550,
	"./Stories/StoryRating": 95660,
	"./Stories/StoryRating.jsx": 95660,
	"./Stories/StoryReader": 20182,
	"./Stories/StoryReader.jsx": 20182,
	"./Stories/StoryRow": 23943,
	"./Stories/StoryRow.jsx": 23943,
	"./Stories/StorySentencePanel": 93912,
	"./Stories/StorySentencePanel.jsx": 93912,
	"./Stories/StorySettingsSheet": 30659,
	"./Stories/StorySettingsSheet.jsx": 30659,
	"./Stories/StorySheet": 10710,
	"./Stories/StorySheet.jsx": 10710,
	"./Stories/StoryText": 50402,
	"./Stories/StoryText.jsx": 50402,
	"./Stories/StoryWordPanel": 61197,
	"./Stories/StoryWordPanel.jsx": 61197,
	"./Stories/WikipediaProgress": 12900,
	"./Stories/WikipediaProgress.jsx": 12900,
	"./Stories/clozeStoryHelpers": 96535,
	"./Stories/clozeStoryHelpers.js": 96535,
	"./Stories/featureFeedback": 39705,
	"./Stories/featureFeedback.js": 39705,
	"./Stories/storiesEvents": 99200,
	"./Stories/storiesEvents.js": 99200,
	"./Stories/storiesHelpers": 38056,
	"./Stories/storiesHelpers.js": 38056,
	"./Stories/storyAudio": 51663,
	"./Stories/storyAudio.js": 51663,
	"./Stories/storyLibrary": 77506,
	"./Stories/storyLibrary.js": 77506,
	"./Stories/storyStorage": 41120,
	"./Stories/storyStorage.js": 41120,
	"./Stories/useAnchoredPopover": 14614,
	"./Stories/useAnchoredPopover.js": 14614,
	"./Stories/useClozeStory": 23409,
	"./Stories/useClozeStory.js": 23409,
	"./Stories/useSaveStoryWord": 63441,
	"./Stories/useSaveStoryWord.js": 63441,
	"./Stories/useStoryAudio": 64306,
	"./Stories/useStoryAudio.js": 64306,
	"./Stories/wikipediaStory": 78754,
	"./Stories/wikipediaStory.js": 78754,
	"./StreakSaves/PixelFire": 87567,
	"./StreakSaves/PixelFire.jsx": 87567,
	"./StreakSaves/StreakSaveAppliedModal": 14608,
	"./StreakSaves/StreakSaveAppliedModal.jsx": 14608,
	"./StreakSaves/StreakSaveAppliedModalContainer": 339,
	"./StreakSaves/StreakSaveAppliedModalContainer.jsx": 339,
	"./StreakSaves/StreakSaveBalanceBtn": 47534,
	"./StreakSaves/StreakSaveBalanceBtn.jsx": 47534,
	"./StreakSaves/StreakSaveEarnedModal": 86644,
	"./StreakSaves/StreakSaveEarnedModal.jsx": 86644,
	"./StreakSaves/StreakSaveExplanationModal": 21974,
	"./StreakSaves/StreakSaveExplanationModal.jsx": 21974,
	"./StreakSaves/StreakSaveIntroModal": 22951,
	"./StreakSaves/StreakSaveIntroModal.jsx": 22951,
	"./Strike": 90350,
	"./Strike.jsx": 90350,
	"./Survey": 16142,
	"./Survey.jsx": 16142,
	"./Survey/ChoiceStep": 76328,
	"./Survey/ChoiceStep.jsx": 76328,
	"./Survey/IntroStep": 83619,
	"./Survey/IntroStep.jsx": 83619,
	"./Survey/NpsStep": 31076,
	"./Survey/NpsStep.jsx": 31076,
	"./Survey/OpenQuestionStep": 5765,
	"./Survey/OpenQuestionStep.jsx": 5765,
	"./Survey/OptionRow": 43794,
	"./Survey/OptionRow.jsx": 43794,
	"./Survey/OtherOptionRow": 49516,
	"./Survey/OtherOptionRow.jsx": 49516,
	"./Survey/ProgressDashes": 49278,
	"./Survey/ProgressDashes.jsx": 49278,
	"./Survey/QuestionStep": 80805,
	"./Survey/QuestionStep.jsx": 80805,
	"./Survey/SurveyContext": 92348,
	"./Survey/SurveyContext.js": 92348,
	"./Survey/SurveyFrame": 91070,
	"./Survey/SurveyFrame.jsx": 91070,
	"./Survey/ThanksStep": 78930,
	"./Survey/ThanksStep.jsx": 78930,
	"./Survey/api": 57017,
	"./Survey/api.js": 57017,
	"./Survey/showIf": 9539,
	"./Survey/showIf.js": 9539,
	"./Survey/useDismissal": 24513,
	"./Survey/useDismissal.js": 24513,
	"./Survey/useSaveResponse": 39340,
	"./Survey/useSaveResponse.js": 39340,
	"./Survey/useSurveyFlow": 75752,
	"./Survey/useSurveyFlow.js": 75752,
	"./TeachingDashboard": 41305,
	"./TeachingDashboard.jsx": 41305,
	"./TeachingDashboard/ClozeSentenceSearch": 75404,
	"./TeachingDashboard/ClozeSentenceSearch.jsx": 75404,
	"./TeachingDashboard/Contributors": 6996,
	"./TeachingDashboard/Contributors.jsx": 6996,
	"./TeachingDashboard/CrosswordViewer": 30854,
	"./TeachingDashboard/CrosswordViewer.jsx": 30854,
	"./TeachingDashboard/EmbedBuilder": 87394,
	"./TeachingDashboard/EmbedBuilder.jsx": 87394,
	"./TeachingDashboard/LinkBuilder": 68989,
	"./TeachingDashboard/LinkBuilder.jsx": 68989,
	"./TeachingDashboard/MyTeachingCollection": 3917,
	"./TeachingDashboard/MyTeachingCollection.jsx": 3917,
	"./TeachingDashboard/ResultsViewer": 39384,
	"./TeachingDashboard/ResultsViewer.jsx": 39384,
	"./TeachingDashboard/SentencesEditor": 49081,
	"./TeachingDashboard/SentencesEditor.jsx": 49081,
	"./Toast": 24367,
	"./Toast.jsx": 24367,
	"./TodaysPlan/ConfirmModal": 40855,
	"./TodaysPlan/ConfirmModal.jsx": 40855,
	"./TodaysPlan/MyCollections": 23555,
	"./TodaysPlan/MyCollections.jsx": 23555,
	"./TodaysPlan/PlayStyleFields": 60392,
	"./TodaysPlan/PlayStyleFields.jsx": 60392,
	"./TodaysPlan/TodaysPlan": 46979,
	"./TodaysPlan/TodaysPlan.jsx": 46979,
	"./TodaysPlan/TodaysPlanAnnouncement": 22042,
	"./TodaysPlan/TodaysPlanAnnouncement.jsx": 22042,
	"./TodaysPlan/TodaysPlanCompleteBanner": 40548,
	"./TodaysPlan/TodaysPlanCompleteBanner.jsx": 40548,
	"./TodaysPlan/TodaysPlanModals": 45129,
	"./TodaysPlan/TodaysPlanModals.jsx": 45129,
	"./TodaysPlan/TodaysPlanPanel": 56529,
	"./TodaysPlan/TodaysPlanPanel.jsx": 56529,
	"./TodaysPlan/TodaysPlanRoundResults": 41705,
	"./TodaysPlan/TodaysPlanRoundResults.jsx": 41705,
	"./TodaysPlan/todaysPlanService": 1382,
	"./TodaysPlan/todaysPlanService.js": 1382,
	"./TodaysPlan/todaysPlanStorage": 63624,
	"./TodaysPlan/todaysPlanStorage.js": 63624,
	"./TodaysPlan/useTodaysPlan": 66292,
	"./TodaysPlan/useTodaysPlan.js": 66292,
	"./TodaysPlan/useTodaysPlanAnnouncement": 90491,
	"./TodaysPlan/useTodaysPlanAnnouncement.js": 90491,
	"./TodaysPlan/useTodaysPlanConfig": 79318,
	"./TodaysPlan/useTodaysPlanConfig.js": 79318,
	"./TravelPhrases": 17304,
	"./TravelPhrases.jsx": 17304,
	"./TravelPhrases/SayIt": 79471,
	"./TravelPhrases/SayIt.jsx": 79471,
	"./TravelPhrases/Wallpaper": 151,
	"./TravelPhrases/Wallpaper.jsx": 151,
	"./TravelPhrases/speech": 30581,
	"./TravelPhrases/speech.js": 30581,
	"./TravelPhrases/srs": 13381,
	"./TravelPhrases/srs.js": 13381,
	"./TravelPhrases/stops": 43230,
	"./TravelPhrases/stops.js": 43230,
	"./UserProfileAttr": 39359,
	"./UserProfileAttr.jsx": 39359,
	"./V5MaxPlayedTodayModal": 41698,
	"./V5MaxPlayedTodayModal.jsx": 41698,
	"./V5Onboarding3": 5669,
	"./V5Onboarding3.jsx": 5669,
	"./V5PlayOptionsModal": 75172,
	"./V5PlayOptionsModal.jsx": 75172,
	"./WorksheetEditor": 9324,
	"./WorksheetEditor/": 9324,
	"./WorksheetEditor/Block": 65851,
	"./WorksheetEditor/Block.jsx": 65851,
	"./WorksheetEditor/SentenceBlock": 81670,
	"./WorksheetEditor/SentenceBlock.jsx": 81670,
	"./WorksheetEditor/SentenceEditor": 66630,
	"./WorksheetEditor/SentenceEditor.jsx": 66630,
	"./WorksheetEditor/SentenceSearchModal": 2986,
	"./WorksheetEditor/SentenceSearchModal.jsx": 2986,
	"./WorksheetEditor/SentenceSearchResult": 26890,
	"./WorksheetEditor/SentenceSearchResult.jsx": 26890,
	"./WorksheetEditor/SentencesBlock": 65979,
	"./WorksheetEditor/SentencesBlock.jsx": 65979,
	"./WorksheetEditor/TextBlock": 51100,
	"./WorksheetEditor/TextBlock.jsx": 51100,
	"./WorksheetEditor/index": 9324,
	"./WorksheetEditor/index.jsx": 9324,
	"./YouTubeConsent/WatchOnYouTubeLink": 59801,
	"./YouTubeConsent/WatchOnYouTubeLink.jsx": 59801,
	"./YouTubeConsent/YouTubeConsentPrompt": 87033,
	"./YouTubeConsent/YouTubeConsentPrompt.jsx": 87033,
	"./YouTubeConsent/useYouTubeConsent": 22448,
	"./YouTubeConsent/useYouTubeConsent.js": 22448,
	"./YouTubeEmbed": 90058,
	"./YouTubeEmbed.jsx": 90058,
	"./admin/BlogPostLanguagePairing": 13942,
	"./admin/BlogPostLanguagePairing.jsx": 13942,
	"./admin/ClozeSentenceSearch/SearchForm": 33009,
	"./admin/ClozeSentenceSearch/SearchForm.jsx": 33009,
	"./admin/CollectionClozeSentenceRow": 20000,
	"./admin/CollectionClozeSentenceRow.jsx": 20000,
	"./admin/CollectionClozeSentences": 1503,
	"./admin/CollectionClozeSentences.jsx": 1503,
	"./admin/CommonVoiceSentenceTr": 56744,
	"./admin/CommonVoiceSentenceTr.jsx": 56744,
	"./admin/QuickMod": 30579,
	"./admin/QuickMod.jsx": 30579,
	"./admin/QuickMod/Tokens": 28878,
	"./admin/QuickMod/Tokens.jsx": 28878,
	"./admin/StatsReportsLineChart": 76994,
	"./admin/StatsReportsLineChart.jsx": 76994,
	"./admin/TTSVoicesTable": 37574,
	"./admin/TTSVoicesTable.jsx": 37574,
	"./admin/TTSVoicesTableRow": 64100,
	"./admin/TTSVoicesTableRow.jsx": 64100,
	"./admin/Words": 18157,
	"./admin/Words.jsx": 18157,
	"./admin/Words/Word": 28906,
	"./admin/Words/Word.jsx": 28906,
	"./mods/ClozeSentenceEditor": 94513,
	"./mods/ClozeSentenceEditor.jsx": 94513,
	"./mods/ClozeSentenceEntry": 36052,
	"./mods/ClozeSentenceEntry.jsx": 36052,
	"./mods/ClozeSentenceTts": 60011,
	"./mods/ClozeSentenceTts.jsx": 60011,
	"./mods/CollectionClozeSentenceChange": 21270,
	"./mods/CollectionClozeSentenceChange.jsx": 21270,
	"./mods/CollectionClozeSentenceChangesModal": 1988,
	"./mods/CollectionClozeSentenceChangesModal.jsx": 1988,
	"./mods/CollectionClozeSentenceEditor": 10065,
	"./mods/CollectionClozeSentenceEditor.jsx": 10065,
	"./mods/CollectionClozeSentenceTts": 83915,
	"./mods/CollectionClozeSentenceTts.jsx": 83915,
	"./mods/TokensEditor": 57297,
	"./mods/TokensEditor.jsx": 57297,
	"./mods/TokensEditorToken": 19622,
	"./mods/TokensEditorToken.jsx": 19622,
	"./quickCloze": 72068,
	"./quickCloze.js": 72068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86900;